const account_center = {
    not_enabled: 'Account Center ist nicht aktiviert.',
    field_not_editable: 'Feld ist nicht bearbeitbar.',
    field_not_enabled: 'Feld ist nicht aktiviert.',
};
export default Object.freeze(account_center);
